import { render, staticRenderFns } from "./IlloPlant.vue?vue&type=template&id=9f0a8096"
import script from "./IlloPlant.vue?vue&type=script&lang=js"
export * from "./IlloPlant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports